import { h } from '@shared/ui/dom.js';

/* Esqueleto de carregamento. O roteador pinta isto ANTES do import() da rota
 * resolver - em 3G a diferenca entre "carregando" e "travado". */

function barra(largura = '100%', altura = '1rem') {
    return h('span', { class: 'sk-barra', style: { width: largura, height: altura } });
}

export function skeletonLista(quantidade = 6) {
    return h(
        'div',
        { class: 'sk', 'aria-hidden': 'true' },
        Array.from({ length: quantidade }, () => h('div', { class: 'sk-linha' }, [h('span', { class: 'sk-circulo' }), h('div', { class: 'sk-coluna' }, [barra('60%'), barra('35%', '0.75rem')])]))
    );
}

export function skeletonDetalhe() {
    return h('div', { class: 'sk', 'aria-hidden': 'true' }, [h('div', { class: 'sk-capa' }), h('div', { class: 'sk-coluna', style: { padding: 'var(--e-4)' } }, [barra('70%', '1.5rem'), barra('45%'), barra('90%'), barra('80%')])]);
}

export function skeletonTabela(linhas = 8) {
    return h('div', { class: 'sk', 'aria-hidden': 'true', style: { padding: 'var(--e-4)' } }, [barra('50%', '1.25rem'), ...Array.from({ length: linhas }, () => h('div', { class: 'sk-linha' }, [h('span', { class: 'sk-circulo', style: { width: '24px', height: '24px' } }), barra('100%')]))]);
}

export function skeletonFormulario() {
    return h('div', { class: 'sk', 'aria-hidden': 'true', style: { padding: 'var(--e-4)' } }, [barra('40%', '1.5rem'), barra('100%', '2.75rem'), barra('100%', '2.75rem'), barra('100%', '2.75rem')]);
}

export function esqueletoDaRota(tipo) {
    switch (tipo) {
        case 'tabela':
            return skeletonTabela();
        case 'detalhe':
            return skeletonDetalhe();
        case 'formulario':
            return skeletonFormulario();
        default:
            return skeletonLista();
    }
}
